/*eslint no-extend-native: off*/

import 'focus-visible/dist/focus-visible.min.js';

Date.prototype.addDays = function (days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};
